var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoresults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0F735871-AA76-4809-A73A-5696959D42F8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "17-advisor-settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "17.3e-UCAP-AdvisorCenter-Advisor-Settings-TeamManagement-NoResults",
    transform: "translate(-838.000000, -331.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(260.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fields",
    transform: "translate(284.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(0.000000, 97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-state",
    transform: "translate(154.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(140.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1387661,0 L11.1971604,0 C9.98786606,0 9.00740741,0.988 9.00740741,2.206875 L9.00740741,61.793125 C9.00740741,63.011875 9.98786606,64 11.1971604,64 L52.8028396,64 C54.0121339,64 54.9925926,63.011875 54.9925926,61.793125 L54.9925926,9.931 L45.1387661,0 Z",
    id: "Shape",
    fill: "#EFF2FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.170370, 0.000000)",
    fill: "#D7DEED"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7835235,9.94722158 L31.1053999,9.94722158 C30.4206824,9.94722158 29.865668,9.3905638 29.865668,8.70381888 L29.865668,0 L39.7835235,9.94722158 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(3.733782, 44.998214) rotate(45.000000) translate(-3.733782, -44.998214) ",
    x: 2.251511,
    y: 41.2211534,
    width: 2.96454252,
    height: 7.55412167
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.4888889,43.0349306 C19.0978783,43.7583738 19.7674329,44.4281668 20.4908761,45.037037 L22.2814815,43.2464316 L20.2794943,41.2444444 L18.4888889,43.0349306 Z",
    id: "Shape",
    fill: "#C7CFE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.17635661,63.5171831 L0.471045622,61.768497 C-0.156994794,61.124469 -0.156994794,60.0803573 0.470923149,59.4363293 L14.0390701,45.5200737 C14.666988,44.8760457 15.6847368,44.8760457 16.3125323,45.5199481 L18.0178433,47.2687599 C18.6458837,47.9127879 18.6458837,48.9568996 18.0179657,49.6009276 L4.45006377,63.5170575 C3.82214582,64.1609599 2.80427455,64.1609599 2.17635661,63.5171831 Z",
    id: "Shape",
    fill: "#707487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.13262226,60.7671351 L16.0541914,47.1266768 C16.6984594,46.4954124 17.7427091,46.4954124 18.3868515,47.1265537 L18.4888889,47.2265316 C18.4888889,47.2265316 18.4877579,47.2251772 18.4872553,47.2244385 L16.7375403,45.5102853 C16.0932722,44.8792671 15.0488969,44.8792671 14.4047545,45.5104084 L0.483185362,59.151113 C-0.161082729,59.7823774 -0.161082729,60.8057965 0.483311024,61.4370609 L2.13161696,63.0518519 C1.48860549,62.4203412 1.48885681,61.3980302 2.13262226,60.7671351 Z",
    id: "Shape",
    fill: "#5B5D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4347211,50.7259259 L18.4705286,49.6900835 C19.1271291,49.0334608 19.1271291,47.9689303 18.4704005,47.3123076 L16.6871929,45.5292959 C16.0305924,44.8729294 14.9662259,44.8729294 14.3097535,45.529424 L13.2740741,46.5651384 L17.4347211,50.7259259 Z",
    id: "Shape",
    fill: "#C7CFE2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.97,
    transform: "translate(13.274074, 45.037037)",
    fill: "#AFB9D2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.73591252,3.20326382 L2.7400127,2.17107692 C3.37659259,1.5166906 4.40838095,1.5166906 5.04483668,2.17094929 L5.14553228,2.2743339 C5.14553228,2.2743339 5.14453898,2.27305755 5.14404233,2.27241937 L3.41520705,0.495480342 C2.77862716,-0.158778348 1.74671464,-0.158778348 1.11025891,0.495607977 L0.10615873,1.52779487 L1.73591252,3.20326382 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 31.762963,
    cy: 32,
    rx: 10.9037037,
    ry: 11.1407407
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.592593, 16.592593)",
    fill: "#D7DEED"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4460502,30.763374 C6.97856153,30.763374 0.090083632,23.8748961 0.090083632,15.4074074 C0.090083632,6.93991876 6.97856153,0.0514408602 15.4460502,0.0514408602 C23.9135388,0.0514408602 30.8020167,6.93991876 30.8020167,15.4074074 C30.8020167,23.8748961 23.9134146,30.763374 15.4460502,30.763374 Z M15.4460502,2.24513262 C8.18841577,2.24513262 2.28377539,8.149773 2.28377539,15.4074074 C2.28377539,22.6650418 8.18841577,28.5696822 15.4460502,28.5696822 C22.7036846,28.5696822 28.608325,22.6650418 28.608325,15.4074074 C28.608325,8.149773 22.7035603,2.24513262 15.4460502,2.24513262 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0271254,16.5043154 L8.86485066,16.5043154 C8.25911589,16.5043154 7.76794265,16.0131422 7.76794265,15.4074074 C7.76794265,14.8016726 8.25911589,14.3104994 8.86485066,14.3104994 L22.0271254,14.3104994 C22.6328602,14.3104994 23.1240335,14.8016726 23.1240335,15.4074074 C23.1240335,16.0131422 22.6328602,16.5043154 22.0271254,16.5043154 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8334337,12.1168076 L16.5428339,12.1168076 C15.9370992,12.1168076 15.4459259,11.6256344 15.4459259,11.0198996 C15.4459259,10.4141649 15.9370992,9.92299164 16.5428339,9.92299164 L19.8334337,9.92299164 C20.4391685,9.92299164 20.9303417,10.4141649 20.9303417,11.0198996 C20.9302174,11.6257587 20.4391685,12.1168076 19.8334337,12.1168076 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0585424,20.8916989 L9.96163441,20.8916989 C9.35589964,20.8916989 8.8647264,20.4005257 8.8647264,19.7947909 C8.8647264,19.1890562 9.35589964,18.6978829 9.96163441,18.6978829 L11.0585424,18.6978829 C11.6642772,18.6978829 12.1554504,19.1890562 12.1554504,19.7947909 C12.1554504,20.4005257 11.6642772,20.8916989 11.0585424,20.8916989 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(25.125926, 26.548148)",
    fill: "#C7CFE2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37428511,2.34091457 L1.15373182,2.34091457 C0.540579894,2.34091457 0.0433922902,1.84117728 0.0433922902,1.22488099 C0.0433922902,0.608584691 0.540579894,0.108847407 1.15373182,0.108847407 L3.37428511,0.108847407 C3.98743704,0.108847407 4.48462464,0.608584691 4.48462464,1.22488099 C4.48449887,1.8413037 3.98743704,2.34091457 3.37428511,2.34091457 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1462845,11.268804 L6.70517793,11.268804 C6.092026,11.268804 5.5948384,10.7690667 5.5948384,10.1527704 C5.5948384,9.53647407 6.092026,9.03673679 6.70517793,9.03673679 L11.1462845,9.03673679 C11.7594364,9.03673679 12.256624,9.53647407 12.256624,10.1527704 C12.2564983,10.7690667 11.7594364,11.268804 11.1462845,11.268804 Z",
    id: "Shape"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoresults);
export default __webpack_public_path__ + "static/media/noresults.cd60c023e7dca392a86a6da3336fe2f0.svg";
export { ForwardRef as ReactComponent };